module.exports = __webpack_public_path__ + "media/application/images/ui/compare-icon-close-6146d2a8fd3b82f84886910988cb466d.png";